import {useContext} from 'react';
import {DarkModeContext} from '../state/darkModeContext';
import {useEffect} from 'react';
import settingsWhite from '../settings/settingsWhite';
import settingsBlack from '../settings/settingsBlack';
import {useCookies} from 'react-cookie';
import {
  enableDarkMode,
  enableLightMode,
} from '../../policeMode/queries/nextcloudTheming';

const useDarkMode = () => {
  const {state, dispatch} = useContext(DarkModeContext);
  const [cookies, setCookie] = useCookies(['darkMode']);

  useEffect(() => {
    console.log('cookies.darkMode', typeof cookies.darkMode);
    if (
      typeof cookies.darkMode === 'undefined' ||
      cookies.darkMode === 'false' || cookies.darkMode === false
    ) {
      setCookie('darkMode', false, {path: '/'});
      dispatch({
        action: 'changeMode',
        payload: {darkMode: false, settings: settingsWhite},
      });
    } else {
      setCookie('darkMode', true, {path: '/'});
      dispatch({
        action: 'changeMode',
        payload: {darkMode: true, settings: settingsBlack},
      });
    }
  }, []);

  const changeModeToDark = () => {
    setCookie('darkMode', true, {path: '/'});
    dispatch({
      action: 'changeMode',
      payload: {darkMode: true, settings: settingsBlack},
    });
    enableDarkMode();
  };

  const changeModeToWhite = () => {
    setCookie('darkMode', false, {path: '/'});
    dispatch({
      action: 'changeMode',
      payload: {darkMode: false, settings: settingsWhite},
    });
    enableLightMode();
  };

  return {mode: state, changeModeToDark, changeModeToWhite};
};

export {useDarkMode};
